'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  color: ', ';\n\n  span {\n    margin: 0;\n    font-weight: 400;\n  }\n'], ['\n  width: 100%;\n  color: ', ';\n\n  span {\n    margin: 0;\n    font-weight: 400;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 12px;\n  margin: 0 0 10px 0;\n  text-align: left;\n'], ['\n  font-size: 12px;\n  margin: 0 0 10px 0;\n  text-align: left;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  width: 430px;\n  & > div {\n    float: left;\n  }\n'], ['\n  display: flex;\n  width: 430px;\n  & > div {\n    float: left;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-weight: 400;\n  font-size: 21px;\n  padding: 3px 0;\n  border-radius: 5px;\n  border-radius: 5px;\n  box-shadow: inset 0 1px 3px 0 rgba(0,0,0,0.35);\n  border: 1px solid ', ';\n\n  span {\n    font-size: 23px;\n    margin: 0;\n    top: 28px;\n    cursor: pointer;\n    color: ', ';\n    margin-right: 10px;\n  }\n\n  input {\n    width: 9em;\n    height: 2.1em;\n    font-weight: 500;\n    font-size: 0.8em;\n    padding: 5px 2px 5px 10px;\n    border: none;\n  }\n\n  input:focus {\n    outline: none;\n  }\n'], ['\n  font-weight: 400;\n  font-size: 21px;\n  padding: 3px 0;\n  border-radius: 5px;\n  border-radius: 5px;\n  box-shadow: inset 0 1px 3px 0 rgba(0,0,0,0.35);\n  border: 1px solid ', ';\n\n  span {\n    font-size: 23px;\n    margin: 0;\n    top: 28px;\n    cursor: pointer;\n    color: ', ';\n    margin-right: 10px;\n  }\n\n  input {\n    width: 9em;\n    height: 2.1em;\n    font-weight: 500;\n    font-size: 0.8em;\n    padding: 5px 2px 5px 10px;\n    border: none;\n  }\n\n  input:focus {\n    outline: none;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  float: left;\n  margin: 13px 16px 0 10px !important;\n'], ['\n  font-size: 16px;\n  float: left;\n  margin: 13px 16px 0 10px !important;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  z-index: 999999;\n  border-left: 0;\n  padding-left: 8px;\n  height: 0px !important;\n  width: 0px !important;\n  overflow: hidden;\n\n  hr {\n    display: none;\n  }\n'], ['\n  z-index: 999999;\n  border-left: 0;\n  padding-left: 8px;\n  height: 0px !important;\n  width: 0px !important;\n  overflow: hidden;\n\n  hr {\n    display: none;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _datePicker = require('material-ui/lib/date-picker/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _MozartRadio = require('../MozartInputBox/MozartRadio');

var _MozartRadio2 = _interopRequireDefault(_MozartRadio);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DateRangeContainer = _styledComponents2.default.div(_templateObject, _color2.default.grey_main);

var DateRangeNote = _styledComponents2.default.p(_templateObject2);

var DatePickerContainer = _styledComponents2.default.div(_templateObject3);

var DatePickerInput = _styledComponents2.default.div(_templateObject4, _color2.default.grey_main, _color2.default.blue_accent);

var DatePickerText = _styledComponents2.default.span(_templateObject5);

var DatePickerPopUp = _styledComponents2.default.div(_templateObject6);

var MozartDateRangeAdvanced = function (_Component) {
  _inherits(MozartDateRangeAdvanced, _Component);

  function MozartDateRangeAdvanced(props) {
    _classCallCheck(this, MozartDateRangeAdvanced);

    var _this = _possibleConstructorReturn(this, (MozartDateRangeAdvanced.__proto__ || Object.getPrototypeOf(MozartDateRangeAdvanced)).call(this, props));

    var startDate = (0, _moment2.default)().subtract(6, 'days').toDate();
    var endDate = (0, _moment2.default)().toDate();
    var startDateMax = (0, _moment2.default)().toDate();
    var endDateMin = (0, _moment2.default)().subtract(6, 'days').toDate();
    var specialcaseNum = null;

    if (props.prevFilterDataStart !== undefined && props.prevFilterDataStart !== '') {
      startDate = props.prevFilterDataStart;
      specialcaseNum = null;
    }
    if (props.prevFilterDataEnd !== undefined && props.prevFilterDataEnd !== '') {
      endDate = props.prevFilterDataEnd;
      specialcaseNum = null;
    }

    startDate = (0, _moment2.default)().subtract(6, 'days').toDate();
    endDate = (0, _moment2.default)().toDate();
    startDateMax = (0, _moment2.default)().toDate();
    endDateMin = (0, _moment2.default)().subtract(6, 'days').toDate();
    specialcaseNum = null;

    if (parseInt(specialcaseNum, 10) === 1) {
      startDate = (0, _moment2.default)().toDate();
      endDate = (0, _moment2.default)().toDate();
      startDateMax = (0, _moment2.default)().toDate();
      endDateMin = startDate;
    }
    if (parseInt(specialcaseNum, 10) === 7) {
      startDate = (0, _moment2.default)().subtract(6, 'days').toDate();
      endDate = (0, _moment2.default)().toDate();
      startDateMax = (0, _moment2.default)().toDate();
      endDateMin = startDate;
    }
    if (parseInt(specialcaseNum, 10) === 30) {
      startDate = (0, _moment2.default)().subtract(29, 'days').toDate();
      endDate = (0, _moment2.default)().toDate();
      startDateMax = (0, _moment2.default)().toDate();
      endDateMin = startDate;
    }
    if (parseInt(specialcaseNum, 10) === 90) {
      startDate = (0, _moment2.default)().subtract(89, 'days').toDate();
      endDate = (0, _moment2.default)().toDate();
      startDateMax = (0, _moment2.default)().toDate();
      endDateMin = startDate;
    }
    if (parseInt(specialcaseNum, 10) === 365) {
      startDate = (0, _moment2.default)().subtract(364, 'days').toDate();
      endDate = (0, _moment2.default)().toDate();
      startDateMax = (0, _moment2.default)().toDate();
      endDateMin = startDate;
    }

    _this.state = {
      update: false,
      start_date: startDate,
      end_date: endDate,
      start_date_max: startDateMax,
      end_date_min: endDateMin,
      specialcase: specialcaseNum
    };
    return _this;
  }

  _createClass(MozartDateRangeAdvanced, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dateType = this.props.dateType;

      var start = this.props.prevFilterDataStart ? this.props.prevFilterDataStart : this.state.start_date;
      var end = this.props.prevFilterDataEnd ? this.props.prevFilterDataEnd : this.state.start_date;
      var specialcase = '';
      if (this.props.specialcase !== undefined) {
        specialcase = this.props.specialcase;
      } else {
        specialcase = (0, _moment2.default)(end).diff(start, 'days') + 1;
        specialcase = specialcase === 1 && (0, _moment2.default)().diff(end, 'days') !== 0 ? 'custom' : specialcase;
      }
      if (specialcase === 1) {
        if (document.getElementById('today_' + dateType) !== null) {
          document.getElementById('today_' + dateType).checked = true;
        }
      } else {
        if (specialcase !== 1 && specialcase !== 7 && specialcase !== 30 && specialcase !== 90 && specialcase !== 365) {
          if (document.getElementById('today_' + dateType) !== null) {
            document.getElementById('customdays_' + dateType).checked = true;
          }
        } else {
          if (document.getElementById('today_' + dateType) !== null) {
            document.getElementById(specialcase + 'days_' + dateType).checked = true;
          }
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var dateType = this.props.dateType;

      var start = nextProps.prevFilterDataStart ? nextProps.prevFilterDataStart : this.state.start_date;
      var end = nextProps.prevFilterDataEnd ? nextProps.prevFilterDataEnd : this.state.end_date;
      var specialcase = nextProps.specialcase !== undefined ? nextProps.specialcase : (0, _moment2.default)(end).diff(start, 'days') + 1;
      this.setState({
        start_date: start,
        end_date: end,
        specialcase: specialcase
      }, function () {
        if (specialcase === 1) {
          if (document.getElementById('today_' + dateType) !== null) {
            document.getElementById('today_' + dateType).checked = true;
          }
        } else {
          if (specialcase !== 1 && specialcase !== 7 && specialcase !== 30 && specialcase !== 90 && specialcase !== 365) {
            if (document.getElementById('today_' + dateType) !== null) {
              document.getElementById('customdays_' + dateType).checked = true;
            }
          } else {
            if (document.getElementById('today_' + dateType) !== null) {
              document.getElementById(specialcase + 'days_' + dateType).checked = true;
            }
          }
        }
        _this2.handleUpdateDateInput();
      });
    }
  }, {
    key: 'onDateBlur',
    value: function onDateBlur(type, event) {
      var value = event.target.value.replace(/-/g, '/');

      var year = value.split('/')[2];
      var leapyear = year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;

      var regex28days = /^(2|02)\/(0[1-9]|1\d|2[012345678]|[1-9])\/(19|20)\d{2}$/;
      var regex29days = /^(2|02)\/(0[1-9]|1\d|2[0123456789]|[1-9])\/(19|20)\d{2}$/;
      var regex28or29days = leapyear ? regex29days : regex28days;

      var regex30days = /^(4|6|9|11|04|06|09)\/(0[1-9]|1\d|2\d|3[0]|[1-9])\/(19|20)\d{2}$/;
      var regex = /^(1|01|3|03|5|05|7|07|8|08|10|12)\/(0[1-9]|1\d|2\d|3[01]|[1-9])\/(19|20)\d{2}$/;

      if (regex28or29days.test(value) || regex30days.test(value) || regex.test(value)) {
        this.validateAndUpdate(type, value);
      } else {
        if (type === 'start_date' && this.refs.start_date_box) {
          this.refs.start_date_box.value = (0, _moment2.default)(this.state.start_date).format('MM/DD/YYYY');
        }
        if (type === 'end_date' && this.refs.end_date_box) {
          this.refs.end_date_box.value = (0, _moment2.default)(this.state.end_date).format('MM/DD/YYYY');
        }
      }
    }
  }, {
    key: 'validateAndUpdate',
    value: function validateAndUpdate(type, value) {
      if (type === 'start_date') {
        if ((0, _moment2.default)(value).isAfter((0, _moment2.default)(this.state.end_date))) {
          this.handleStartDateChange({}, (0, _moment2.default)(this.state.start_date).format('MM/DD/YYYY'));
        } else {
          this.handleStartDateChange({}, value);
        }
      }
      if (type === 'end_date') {
        if ((0, _moment2.default)(value).isAfter(new Date()) || (0, _moment2.default)(value).isBefore((0, _moment2.default)(this.state.start_date))) {
          this.handleEndDateChange({}, (0, _moment2.default)(this.state.end_date).format('MM/DD/YYYY'));
        } else {
          this.handleEndDateChange({}, value);
        }
      }
    }
  }, {
    key: 'getData',
    value: function getData(value) {
      var totalDays = new Date().getFullYear() % 4 === 0 ? 366 : 365;
      var start = new Date();
      var end = new Date();
      var specialcase = null;
      switch (value) {
        case '1':
          start = new Date();
          end = new Date();
          specialcase = 1;
          break;
        case '7':
          start = (0, _moment2.default)().subtract(6, 'days').toDate();
          end = new Date();
          specialcase = 7;
          break;
        case '30':
          start = (0, _moment2.default)().subtract(29, 'days').toDate();
          end = new Date();
          specialcase = 30;
          break;
        case '90':
          start = (0, _moment2.default)().subtract(89, 'days').toDate();
          end = new Date();
          specialcase = 90;
          break;
        case '365':
          start = (0, _moment2.default)().subtract(totalDays - 1, 'days').toDate();
          end = new Date();
          specialcase = 365;
          break;
        case 'customdays':
          start = this.state.start_date;
          end = this.state.end_date;
          specialcase = 'custom';
          break;
        default:
          start = new Date();
          end = new Date();
          break;
      }
      this.setState({ end_date_min: start });
      return {
        start: start,
        end: end,
        specialcase: specialcase
      };
    }
  }, {
    key: 'handleStartDateChange',
    value: function handleStartDateChange(event, value) {
      var _this3 = this;

      var _props = this.props,
          noprefix = _props.noprefix,
          handleChange = _props.handleChange;

      this.setState({
        start_date: new Date(value),
        end_date: this.state.end_date,
        end_date_min: new Date(value)
      }, function () {
        if (_this3.refs.start_date_box) {
          _this3.refs.start_date_box.value = (0, _moment2.default)(_this3.state.start_date).format('MM/DD/YYYY');
        }
        // will break anything ? we already set state up there plus this component is going away soon
        // this.state.start_date = new Date(value);
        // this.state.end_date_min = new Date(value);
        handleChange('start_date', _this3.state.start_date, '', _this3.props.dateType);
        if (!noprefix) {
          handleChange('specialcase', 'customdays', '', _this3.props.dateType);
        }
        if (_this3.refs.customdays) {
          _this3.refs.customdays.checked = true;
        }
      });
    }
  }, {
    key: 'handleEndDateChange',
    value: function handleEndDateChange(event, value) {
      var _this4 = this;

      var _props2 = this.props,
          noprefix = _props2.noprefix,
          handleChange = _props2.handleChange;

      this.setState({
        start_date: this.state.start_date,
        end_date: new Date(value),
        start_date_max: new Date(value)
      }, function () {
        if (_this4.refs.end_date_box) {
          _this4.refs.end_date_box.value = (0, _moment2.default)(_this4.state.end_date).format('MM/DD/YYYY');
        }
        // will break anything ? we already set state up there plus this component is going away soon
        // this.state.end_date = new Date(value);
        // this.state.start_date_max = new Date(value);
        handleChange('end_date', _this4.state.end_date, '', _this4.props.dateType);
        if (!noprefix) {
          handleChange('specialcase', 'customdays', '', _this4.props.dateType);
        }
        if (_this4.refs.customdays) {
          _this4.refs.customdays.checked = true;
        }
      });
    }
  }, {
    key: 'handleRadioBoxClick',
    value: function handleRadioBoxClick(dateType, event) {
      var _this5 = this;

      var handleChange = this.props.handleChange;

      var selected = event.target.value;
      var data = this.getData(selected);
      var start = data.start;
      var end = data.end;
      var specialcase = data.specialcase;
      this.setState({
        start_date: start,
        end_date: end,
        specialcase: specialcase
      }, function () {
        handleChange('start_date', start, selected, dateType);
        handleChange('end_date', end, selected, dateType);
        handleChange('specialcase', specialcase, selected, dateType);
        _this5.handleUpdateDateInput();
      });
    }
  }, {
    key: 'handleUpdateDateInput',
    value: function handleUpdateDateInput() {
      if (this.refs.start_date_box) {
        this.refs.start_date_box.value = (0, _moment2.default)(this.state.start_date).format('MM/DD/YYYY');
      }
      if (this.refs.end_date_box) {
        this.refs.end_date_box.value = (0, _moment2.default)(this.state.end_date).format('MM/DD/YYYY');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props3 = this.props,
          noprefix = _props3.noprefix,
          id = _props3.id,
          testId = _props3.testId,
          themeId = _props3.themeId,
          dateType = _props3.dateType;

      return _react2.default.createElement(
        DateRangeContainer,
        { 'data-qa': testId, 'data-theme': themeId },
        _react2.default.createElement(
          DateRangeNote,
          null,
          'All dates and times in ',
          this.props.timezone
        ),
        !noprefix && _react2.default.createElement(
          _MozartRadio2.default,
          null,
          _react2.default.createElement('input', {
            ref: "today_" + dateType,
            key: "today_" + dateType,
            type: 'radio',
            id: "today_" + dateType,
            name: "date_selector_" + dateType,
            className: "binary_radio_" + dateType,
            onChange: this.handleRadioBoxClick.bind(this, dateType),
            defaultChecked: this.state.specialcase === 1,
            defaultValue: '1'
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: "today_" + dateType, className: 'binary_radio_label' },
            'Today'
          )
        ),
        !noprefix && _react2.default.createElement(
          _MozartRadio2.default,
          null,
          _react2.default.createElement('input', {
            ref: "7days_" + dateType,
            key: "7days_" + dateType,
            type: 'radio',
            id: "7days_" + dateType,
            name: "date_selector_" + dateType,
            className: 'binary_radio',
            onChange: this.handleRadioBoxClick.bind(this, dateType),
            defaultChecked: this.state.specialcase === 7,
            defaultValue: '7'
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: "7days_" + dateType, className: 'binary_radio_label' },
            '7 Days'
          )
        ),
        !noprefix && _react2.default.createElement(
          _MozartRadio2.default,
          null,
          _react2.default.createElement('input', {
            ref: "30days_" + dateType,
            key: "30days_" + dateType,
            type: 'radio',
            id: "30days_" + dateType,
            name: "date_selector_" + dateType,
            className: 'binary_radio',
            onChange: this.handleRadioBoxClick.bind(this, dateType),
            defaultChecked: this.state.specialcase === 30,
            defaultValue: '30'
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: "30days_" + dateType, className: 'binary_radio_label' },
            '30 Days'
          )
        ),
        !noprefix && _react2.default.createElement(
          _MozartRadio2.default,
          null,
          _react2.default.createElement('input', {
            ref: "90days_" + dateType,
            key: "90days_" + dateType,
            type: 'radio',
            id: "90days_" + dateType,
            name: "date_selector_" + dateType,
            className: 'binary_radio',
            onChange: this.handleRadioBoxClick.bind(this, dateType),
            defaultChecked: this.state.specialcase === 90,
            defaultValue: '90'
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: "90days_" + dateType, className: 'binary_radio_label' },
            '90 Days'
          )
        ),
        !noprefix && _react2.default.createElement(
          _MozartRadio2.default,
          null,
          _react2.default.createElement('input', {
            ref: "365days_" + dateType,
            key: "365days_" + dateType,
            type: 'radio',
            id: "365days_" + dateType,
            name: "date_selector_" + dateType,
            className: 'binary_radio',
            onChange: this.handleRadioBoxClick.bind(this, dateType),
            defaultChecked: this.state.specialcase === 365,
            defaultValue: '365'
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: "365days_" + dateType, className: 'binary_radio_label' },
            '1 Year'
          )
        ),
        !noprefix && _react2.default.createElement(
          _MozartRadio2.default,
          null,
          _react2.default.createElement('input', {
            ref: "customdays_" + dateType,
            key: "customdays_" + dateType,
            type: 'radio',
            id: "customdays_" + dateType,
            name: "date_selector_" + dateType,
            className: 'binary_radio',
            onChange: this.handleRadioBoxClick.bind(this, dateType),
            defaultChecked: this.state.specialcase === null,
            defaultValue: 'custom'
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: "customdays_" + dateType, className: 'binary_radio_label' },
            'Custom'
          )
        ),
        _react2.default.createElement(
          DatePickerContainer,
          null,
          _react2.default.createElement(
            DatePickerInput,
            null,
            _react2.default.createElement('input', {
              placeholder: 'MM/DD/YYYY',
              onBlur: this.onDateBlur.bind(this, 'start_date'),
              ref: 'start_date_box',
              id: 'start_date_box',
              key: 'start_date' + id,
              type: 'text'
            }),
            _react2.default.createElement('span', { className: 'icon-Calendar', onClick: function onClick() {
                if (_this6.refs.filter_start_date) {
                  _this6.refs.filter_start_date.focus();
                }
              } })
          ),
          _react2.default.createElement(
            DatePickerPopUp,
            null,
            _react2.default.createElement(_datePicker2.default, {
              ref: 'filter_start_date',
              onChange: this.handleStartDateChange.bind(this),
              value: this.state.start_date,
              defaultChecked: false,
              formatDate: function formatDate(date) {
                return (0, _moment2.default)(date).format('MM/DD/YYYY');
              },
              mode: 'landscape',
              key: 'start_date' + id,
              id: 'binary_customdays_start',
              maxDate: this.state.start_date_max,
              container: 'inline' })
          ),
          _react2.default.createElement(
            DatePickerText,
            null,
            ' to '
          ),
          _react2.default.createElement(
            DatePickerInput,
            null,
            _react2.default.createElement('input', {
              placeholder: 'MM/DD/YYYY',
              onBlur: this.onDateBlur.bind(this, 'end_date'),
              id: 'end_date_box',
              key: 'end_date' + id,
              ref: 'end_date_box',
              type: 'text'
            }),
            _react2.default.createElement('span', { className: 'icon-Calendar', onClick: function onClick() {
                if (_this6.refs.filter_end_date) {
                  _this6.refs.filter_end_date.focus();
                }
              } })
          ),
          _react2.default.createElement(
            DatePickerPopUp,
            null,
            _react2.default.createElement(_datePicker2.default, {
              ref: 'filter_end_date',
              mode: 'landscape',
              textFieldStyle: { 'width': '10000px' },
              value: this.state.end_date,
              id: 'binary_customdays_end',
              key: 'end_date' + id,
              formatDate: function formatDate(date) {
                return (0, _moment2.default)(date).format('MM/DD/YYYY');
              },
              onChange: this.handleEndDateChange.bind(this),
              maxDate: new Date(),
              minDate: this.state.end_date_min,
              container: 'inline' })
          )
        )
      );
    }
  }]);

  return MozartDateRangeAdvanced;
}(_react.Component);

MozartDateRangeAdvanced.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  cancel: _propTypes2.default.bool,
  prevFilterDataStart: _propTypes2.default.object,
  prevFilterDataEnd: _propTypes2.default.object,
  /** if true no radio box prefix Today 7 days 30 days ... */
  noprefix: _propTypes2.default.bool,
  /** when set the default radio box will be checked */
  specialcase: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /** when changed this will get called 3 times with name and value as params for the callback. Names are start_date, end_date and specialcase(30, 90, 365, null) null means custom */
  handleChange: _propTypes2.default.func.isRequired,
  /** timezone label */
  timezone: _propTypes2.default.string,
  /** id */
  id: _propTypes2.default.string,
  /** This will help to create multiple date filters on the same page */
  dateType: _propTypes2.default.string
};
MozartDateRangeAdvanced.defaultProps = {
  cancel: false,
  timezone: 'CST',
  noprefix: false,
  id: Math.random(),
  testId: 'MozartDateRange',
  themeId: 'MozartDateRange',
  dateType: 'default'
};
exports.default = MozartDateRangeAdvanced;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartDateRangeAdvanced/MozartDateRangeAdvanced.js
// module id = 2083
// module chunks = 1